export default "__VITE_ASSET__BmXUalIe__"